"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageTypeUpid = void 0;
const types_1 = require("../types");
const maps_1 = require("../types/maps");
const utils_1 = require("./utils");
const buildNavigationContent = ({ pageType, url, languageCode, pageId, pageTitle, }) => {
    if (pageType === types_1.PageType.BRANDS) {
        return `Marken/${pageTitle}`;
    }
    return `${pageId}${(0, exports.pageTypeUpid)(pageType, url, languageCode)}`;
};
const buildNavigationPageId = ({ pageType, pageTitle, }) => {
    if (pageType === types_1.PageType.BRANDS) {
        return `Marken/${pageTitle}`;
    }
    return maps_1.pageTypeContentAndPageIdMap.get(pageType);
};
function getPageNumber(url) {
    return (url.searchParams &&
        (0, utils_1.sanitizeUrl)(url.searchParams.get('pageNumber') || url.searchParams.get('page') || '1'));
}
exports.default = (pageType, url, languageCode, options) => {
    const pageId = buildNavigationPageId({
        pageType,
        pageTitle: options === null || options === void 0 ? void 0 : options.pageTitle,
    });
    return {
        content: buildNavigationContent({
            pageId,
            pageType,
            url,
            languageCode,
            pageTitle: options === null || options === void 0 ? void 0 : options.pageTitle,
        }),
        deepLink: `${url.pathname}`,
        domain: url.host,
        pageId,
        pageNumber: getPageNumber(url),
        requestUrl: encodeURIComponent(url.href),
        siteType: maps_1.pageTypeSiteTypeMap.get(pageType),
    };
};
const pageTypeUpid = (pageType, url, languageCode) => {
    var _a, _b;
    switch (pageType) {
        case types_1.PageType.OFFER:
        case types_1.PageType.PDP:
        case types_1.PageType.PDP_AFTER_LOGIN:
        case types_1.PageType.PDP_AFTER_REGISTRATION: {
            const upidMinLength = 8;
            // for ch tenant we also have language in the url
            const [, , pzn] = (_b = (_a = url.pathname) === null || _a === void 0 ? void 0 : _a.replace(new RegExp(`^\\/${languageCode}\\/`), '/')) === null || _b === void 0 ? void 0 : _b.split('/');
            return pzn ? `/${pzn === null || pzn === void 0 ? void 0 : pzn.padStart(upidMinLength, '0')}` : '';
        }
        case types_1.PageType.SEARCH_RESULTS: {
            return `/${getSearchType(url.searchParams)} Suche`;
        }
        default: {
            return '';
        }
    }
};
exports.pageTypeUpid = pageTypeUpid;
/**
 * If there's neither of these params, but we got a search results page,
 * then it's defined as an "external search" which might be triggered
 * for users coming from Newsletter, Google, etc. and landing on a SERP.
 * But also onsite this might happen if you click on "show all" in the cross-sell widgets.
 *
 * Every search that has happened onsite in the shop (triggered via the search box),
 * gets a `i=1` param as is defined as "internal search" in econda tracking.
 *
 * `B=1` is triggered by a click on a banner which redirects to a SERP (`b` is an alias).
 */
const getSearchType = (searchParams) => {
    if (searchParams.get('i') === '1') {
        return 'interne';
    }
    if (searchParams.get('B') === '1' || searchParams.get('b') === '1') {
        return 'teaser';
    }
    return 'externe';
};
//# sourceMappingURL=create.navigation.data.js.map